import { ActionReducerMapBuilder } from "@reduxjs/toolkit";
import { getOrdersByFilter } from "../ordersThunk";
import { OrdersState } from "../types";
import { CustomError } from "shared/api";
import { groupOrdersByDate } from "entities/orders";

export const getOrdersByFilterReducer = (builder: ActionReducerMapBuilder<OrdersState>) => {
	builder
		.addCase(getOrdersByFilter.pending, state => {
			state.loading = true;
			state.loadingOrderGroups = true;
		})
		.addCase(getOrdersByFilter.fulfilled, (state, action) => {
			state.loadingOrderGroups = false;
			const results = action.payload.results;

			if (!results.length) {
				state.ordersGroups = [];
			}

			const groupedOrders = groupOrdersByDate(results, state);

			const page = action.meta.arg.page;
			if (page && page > 1) {
				state.ordersGroups =
					state.ordersGroups.concat(groupedOrders);
			} else if (groupedOrders.length) {
				state.ordersGroups = groupedOrders;
			}

			state.stats = action.payload.stats;

			state.error = null;
		})

		.addCase(getOrdersByFilter.rejected, (state, action) => {
			state.loadingOrderGroups = false;
			state.stats = {
				appointments: 'error',
				participants: 'error',
			};
			state.error = action.payload as CustomError;
		})
}